export default __webpack_public_path__ + "static/media/DR_Icon.5a0f72a6.svg";